import config from 'config';

import { getProfileSizeFiltersToApply } from './getProfileSizeFiltersToApply';

const profileSizesToAggregations = (profileSizes) => {
  const baseFields = Object.keys(profileSizes);
  const fields = [...new Set([...baseFields])];
  const defaultSize = 50;

  return fields.map((field) => ({
    field: field,
    size: defaultSize,
  }));
};

export const getRecommendedWearItWithFilters = ({
  masterProductIds = [],
  profileSizes = {},
  size = config.get('public.brand.pdpWearItWith.size'),
  shouldAutoFilterWearItWith,
}) => {
  const aggregations = profileSizesToAggregations(profileSizes);

  let baseFilters = {
    includeOutOfStock: false,
    masterProductIds,
    size,
    boostedIds: masterProductIds,
    aggregationFilter: {},
    aggregations,
  };

  if (
    profileSizes &&
    Object.keys(profileSizes).length !== 0 &&
    shouldAutoFilterWearItWith
  ) {
    const autoAppliedFilters = getProfileSizeFiltersToApply(
      profileSizes,
      baseFilters
    );
    baseFilters = {
      ...baseFilters,
      aggregationFilter: {
        ...autoAppliedFilters,
      },
    };
  }

  return baseFilters;
};
